import { createContext } from 'react';

import { initialBaseContext, TEnvironmentSettings } from '@pb/services';

const appSpecificContext = {};

const initialContext: TEnvironmentSettings = {
    ...initialBaseContext,
    ...appSpecificContext,
};

export const EnvironmentContext =
    createContext<TEnvironmentSettings>(initialContext);
